import React, { useState, useEffect } from 'react';
import { XCloseIcon, ClockOutlineIcon, CaretIcon } from '@rsos/assets/icons';
import { CloseButton } from '@rsos/components/capstone/DataCards/DataCards.styles';
import { Button } from '@rsos/components/capstone/base';
import Box from '@rsos/components/capstone/base/Box';
import Dropdown from '@rsos/components/capstone/base/Dropdown';
import { DropdownBody } from '@rsos/components/capstone/base/Dropdown/DropdownComponents';
import { AnimateRotate } from '@rsos/utils/springAnimations';
import { trackHistoricToggle } from '../../JurisdictionView/jurisdictionViewTrackings';
import HistoricLocations from '../HistoricLocations';
import {
  ContainerBox,
  HeadlineText,
  HeadlineContainer,
  Resizer,
} from './HistoricLocationsToggle.styles';

const HistoricLocationsToggle = ({ irpVersion, locations }) => {
  const [isDropdownClicked, setIsDropdownClicked] = useState(false);

  const ClockOutlineMenu = ({ onClick, selected }) => {
    useEffect(() => {
      setIsDropdownClicked(selected);
    }, [selected]);

    const handleHistoricLocationsToggle = () => {
      trackHistoricToggle(isDropdownClicked, irpVersion);
      setIsDropdownClicked(!isDropdownClicked);
      onClick();
    };
    return (
      <Button
        btnType="tertiary"
        size="xsmall"
        onClick={handleHistoricLocationsToggle}
        type="button"
        noMargin
        px={2}
      >
        <Box pr={1}>
          <ClockOutlineIcon color="primaryText" />
        </Box>
        <AnimateRotate
          config={{ duration: 0 }}
          rotate={!isDropdownClicked}
          from={0}
          to={180}
        >
          <CaretIcon height={10} width={10} color="secondaryLink" />
        </AnimateRotate>
      </Button>
    );
  };
  const handleModalClose = onDropdownClose => {
    setIsDropdownClicked(false);
    onDropdownClose();
  };

  return (
    <Box>
      <Dropdown triggerElement={ClockOutlineMenu} triggerOnClose>
        {onDropdownClose => (
          <DropdownBody>
            <ContainerBox>
              <HeadlineContainer horizontal p={2}>
                <HeadlineText>Location History</HeadlineText>
                <CloseButton onClick={() => handleModalClose(onDropdownClose)}>
                  <XCloseIcon />
                </CloseButton>
              </HeadlineContainer>
              <HistoricLocations locations={locations} />
              <Resizer />
            </ContainerBox>
          </DropdownBody>
        )}
      </Dropdown>
    </Box>
  );
};

export default HistoricLocationsToggle;
